import Grid from '@material-ui/core/Grid'
import EurestoForm from 'Components/Form'
import Traduction from 'Components/Traduction'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor(props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount() {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getMessage()
    }
  }

  getMessage = async () => {
    const result = await ApiRequest(project.api + 'commun', {
      requete: 'template',
      action: 'get',
      type_id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: 'Email',
        info: result.results.info,
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      info: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'commun', {
      requete: 'template',
      action: 'set',
      type_id: this.state.id,
      info: this.state.info,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'commun', {
      requete: 'template',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }}
        spacing={0} direction="column" justify="flex-start"
        alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          height={User.CalculHeight.getHeightWanted(200)}
          onChange={this.onChangeState}
          name={'info'}
          disabled={disabled}
          data={this.state.info !== undefined ? this.state.info : []}
          type={Constants.typeSaisie.Wysiwyg}
        />
      </Grid>
    )
  }

  saveDesign = () => {
    this.editor.saveDesign(design => {
      alert('Design JSON has been logged in your developer console.')
    })
  }

  exportHtml = () => {
    this.editor.exportHtml(data => {
      const { design, html } = data
      alert('Output HTML has been logged in your developer console.')
    })
  }

  render() {
    console.log(this.props.isAllow)
    return (
      <EurestoForm key={this.state.key}
        {...this.props.formProps}
        libelle={'Message'}
        buttons={[{
          title: 'Générer',
          className: 'EurestoSecondary--text',
          icon: ' ei-commun_modifier',
          cb: this.generateHeader,
          isAllow: this.state.id === 1
        }]}
        action={this.state.action}
        isAllow={{ add: false, update: true, delete: false, archive: false, duplicate: false }}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onDelete={this.onDelete}
        onArchive={this.onArchive}
        onView={this.onView}
        libelleAdd={EurestoI18n.t('commun:Message')}
        children={this.form} />
    )
  }

  generateHeader = () => {
    this.setState({
      action: 'update',
      key: Utils.getRandomNumber(),
      info: [{
        text: `<div>
                            <p>
                                <span>${User.Entite.get().media_lien && `<img style="width: 200px;" alt="Logo" src="${User.Entite.get().media_lien}"/>` || ''}</span>
                            </p>
                            <p style="text-align: center; font-size: 15px;">
                                <strong>${User.Entite.get().libelle}</strong><br/>
                                ${User.Entite.get().adresse1 && `<span>${User.Entite.get().adresse1}</span><br/>` || ''}
                                ${User.Entite.get().cp && `<span>${User.Entite.get().cp}${User.Entite.get().ville && ',' || '<br/>'}</span>` || ''}
                                ${User.Entite.get().ville && `<span>${User.Entite.get().ville}</span><br/>` || ''}
                                ${(User.Entite.get().fixe || User.Entite.get().portable) && `<span>${User.Entite.get().fixe || User.Entite.get().portable}</span><br/>` || ''}
                                ${(User.Entite.get().email) && `<a href="mailto:${User.Entite.get().email || ''}">${User.Entite.get().email}</a><br/>` || ''}
                            </p>
                        </div>`,
        langue_id: 1
      }]
    })
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Reservation/Message.js